// eslint-disable-next-line no-restricted-imports
import { parsePhoneNumber as parse } from 'libphonenumber-js/min';

const DEFAULT_COUNTRY = 'US';

export function parsePhoneNumber(input: string) {
	return parse(input, DEFAULT_COUNTRY);
}
